import { Directive, Self } from '@angular/core';
import { NgControl, NgControlStatus } from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[formControlName],[ngModel],[formControl]',
  host: {
    '[class.ion-untouched]': 'isUntouched',
    '[class.ion-touched]': 'isTouched',
    '[class.ion-pristine]': 'isPristine',
    '[class.ion-dirty]': 'isDirty',
    '[class.ion-valid]': 'isValid',
    '[class.ion-invalid]': 'isInvalid',
    '[class.ion-pending]': 'isPending',
  },
})
export class IonControlStatus extends NgControlStatus {
  // eslint-disable-next-line @angular-eslint/prefer-inject,new-cap
  constructor(@Self() cd: NgControl) {
    super(cd);
  }
}
